import { render, staticRenderFns } from "./EntitiesPagination.vue?vue&type=template&id=2ba69ae2&"
import script from "./EntitiesPagination.vue?vue&type=script&lang=js&"
export * from "./EntitiesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba69ae2')) {
      api.createRecord('2ba69ae2', component.options)
    } else {
      api.reload('2ba69ae2', component.options)
    }
    module.hot.accept("./EntitiesPagination.vue?vue&type=template&id=2ba69ae2&", function () {
      api.rerender('2ba69ae2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/management/entities/views/components/EntitiesPagination.vue"
export default component.exports